import { render, staticRenderFns } from "./MealSelectionPanel.vue?vue&type=template&id=606cb227&scoped=true"
import script from "./MealSelectionPanel.vue?vue&type=script&lang=ts"
export * from "./MealSelectionPanel.vue?vue&type=script&lang=ts"
import style0 from "./MealSelectionPanel.vue?vue&type=style&index=0&id=606cb227&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606cb227",
  null
  
)

export default component.exports